import React from 'react'
import { Link } from 'react-router-dom'
import { useRef } from "react";
import Slider from "react-slick";
import { DateConvert } from "../../helper/DateConvert";
import { BaseUrl, getAssetUrl } from "../../helper/BaseUrl";
import { useEffect, useState } from "react";

export default function HomeBlog({ initialData }) {
    const [allData, setAllData] = useState(initialData || []);
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 3,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
        centerMode: true,
        centerPadding: '0',
        responsive: [
            {
                breakpoint: 767,
                settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true, },
            },
        ],
    };





    // API Calling
    const fetcher = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/blogs`, {
                method: 'GET',
            });

            const result = await response.json();

            if (result.blogs === false) {
                throw new Error(`API error: ${result.message}`);
            }
            setAllData(result.blogs);
        } catch (error) {
            console.error('Fetch error:', error.message);
        }
    };

    useEffect(() => {
        fetcher();
    }, [])

    if (!allData) {
        return <div style={{ height: "100vh", width: "100%" }}></div>;
    }

    const CustomArrows = () => (
        <>
            <div className="default-arrow default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
                <i className="fa-solid fa-arrow-left"></i>
            </div>
            <div className="default-arrow default-mobilearrow default-arrowright" onClick={() => sliderRef.current.slickNext()}>
                <i className="fa-solid fa-arrow-right"></i>
            </div>
        </>
    );

    return (
        <>
            <section className="homeblog-head">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12">
                            <div className="bloghead-detail">
                                <h4 className="heading">The World <span>of native sutra</span></h4>

                                <Link to={"/blog/"} className="default-butn">
                                    <span className="text">Explore insights</span>
                                    <div className="icon-container">
                                        <div className="icon icon--left">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </div>
                                        <div className="icon icon--right">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="homeblog">
                <div className="container">
                    <div className="row justify-content-end">
                        <div className="col-lg-6 col-md-6">
                            <p className="howwork-para">Discover a world where design, culture, and craftsmanship come together to create timeless interiors.</p>
                        </div>

                        <div className="col-lg-12">
                            <div className="blog-slider">
                                <Slider {...settings} ref={sliderRef}>
                                    {allData && allData.slice(0,4).map((data, index) => (
                                        <div className="blogpost-box" key={index} >
                                            <Link to={`/blog/${data?.slug}/`} >
                                                <picture>
                                                    <img src={getAssetUrl(data?.thumbnail)} className="img-responsive" alt={data?.alt_thumbnail} loading="lazy" />
                                                </picture>
                                                <div><span>{`${Math.max(1, Math.round((data?.description1?.length || 0) / 200))} Min`}  </span> <span>{DateConvert(data?.date)}</span></div>
                                                <p>{data?.title?.slice(0, 220) + "..."}</p>
                                                <small>Learn More <i className="fa-solid fa-arrow-right"></i></small>
                                            </Link>
                                        </div>
                                    ))}

                                </Slider>
                                <CustomArrows />
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}
